import React from 'react';
import { PageTitleContainer, PageTitleIcon, PageTitleText } from './PageTitle.styles';

interface IconProp {
    src: string;
    style?: React.CSSProperties;
    className?: string;
}

interface Props {
    title: string;
    children?: React.ReactNode;
    showMenu?: boolean;
    iconProp?: IconProp;
    iconTitleGap?: number;
}

const PageTitle: React.FC<Props> = ({
    title,
    children,
    showMenu = true,
    iconProp,
    iconTitleGap,
}) => {
    return (
        <PageTitleContainer $showMenu={showMenu} $iconTitleGap={iconTitleGap}>
            {iconProp && (
                <PageTitleIcon
                    src={`src/assets/images/${iconProp.src}`}
                    preview={false}
                    style={iconProp.style}
                    className={iconProp.className}
                />
            )}
            {title ? (
                <PageTitleText showMenu={showMenu}>{title}</PageTitleText>
            ) : (
                <PageTitleText showMenu={showMenu} className="invisible-title">
                    title
                </PageTitleText>
            )}
            {children}
        </PageTitleContainer>
    );
};

export default PageTitle;
